import {gql} from 'apollo-boost'

export default gql`query{
  projects{
    project_id_prefix
    project_id
    name
    project_status{
      project_status_id
      description
      hexcode
    }
    project_manager{
      user_id
      first_name
      last_name
    }
    project_director{
      user_id
      first_name
      last_name
    }
    clients{
      name
    }
    total_budget
    total_fees
    total_supplier_invoiced
    total_writeoff
    total_invoiced
    total_credit_notes
    amount_to_invoice
    project_activity_budgets{
      description
      amount
      budget_total
      budget_used
      project_activity_type{
        description
      }
    }
  }
}`